import { RelocationOrderTransportReason } from "@/api-schema-enums";
import { RELOCATION_ORDER_TRANSPORT_REASON_TRANSLATIONS } from "@/components/relocation-order/relocation-order-transport-reason-translations";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

export const RELOCATION_ORDER_TRANSPORT_REASON_FILTER_OPTIONS = Object.values(RelocationOrderTransportReason).map(
  (reason) => ({
    id: reason,
    name: RELOCATION_ORDER_TRANSPORT_REASON_TRANSLATIONS[reason],
  }),
);

export class RelocationOrderTransportReasonFilter extends Filter<unknown, unknown> {
  readonly labelSingular = "fit:TransportReason";
  readonly labelPlural = "fit:TransportReason";
  readonly placeholder = "fit:SelectTransportReason";
  readonly searchPlaceholder = "fit:SearchTransportReason";
  readonly emptyText = "fit:NoTransportReasonFound";

  constructor(options?: { id: RelocationOrderTransportReason; name: string }[], { id }: { id?: string } = {}) {
    super();
    this.options = options ?? RELOCATION_ORDER_TRANSPORT_REASON_FILTER_OPTIONS;
    if (id) this.id = id;
  }

  readonly id: string = "transportReason";

  options: { id: RelocationOrderTransportReason; name: string }[] = [];

  getData(): FilterData {
    return {
      options: this.options,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
